module.exports = __webpack_public_path__ + "static/media/art43.0df957f0.jpg";